import { jsx as _jsx } from "react/jsx-runtime";
import { Button, useLocalizeMessage, Spinner } from 'libs.nucleus';
import { useDownloadFromGCS } from '../../hooks';
export const DownloadReportAction = ({ url, fileName }) => {
    const translate = useLocalizeMessage();
    const { downloadFileFromGCSPath, isDownloading } = useDownloadFromGCS();
    if (!url) {
        return null;
    }
    return (_jsx("div", { className: 'flex justify-center', children: _jsx(Button, { variant: 'transparent', label: translate('Download'), disabled: isDownloading, onClick: () => downloadFileFromGCSPath({ url, fileName }), content: isDownloading ? (_jsx("div", { className: 'py-1', children: _jsx(Spinner, { size: 'sm' }) })) : undefined }) }));
};
